<template>
  <div class="analytics newsletter-analytics mb-3">
    <data-warning
      :disabled="isDisabled"
      :incomplete="isIncomplete"
      :type="analyticsType"
      :published-recently="publishedPast2hours"
    />

    <filter-bar
      v-if="!isDisabled"
      :timeframe="timeframe"
      :switch-timeframe="false"
      @change="() => null"
    />

    <stats
      :data="basicMetrics"
      :props="basicMetricsShow"
      :min-width="minWidth"
      :disabled="isDisabled"
    />

    <funnel-chart
      v-if="dimensions"
      :width="dimensions.width"
      :height="500"
      :client-width="clientWidth"
      :min-width="minWidth + 250"
      :items="funnelItems"
      :processed="funnelProcessed"
      :type="analyticsType"
      :labels-long="['Emails Delivered', 'Unique Email Opens',  'Unique Click Throughs']"
      :labels-short="['DELI', 'OPEN', 'CLICK', 'CLICK']"
      :disabled="isDisabled"
    />

    <!-- <bar-chart
      v-if="dimensions"
      :width="dimensions.width"
      :height="500"
      :client-width="clientWidth"
      :min-width="minWidth"
      :items="barChartItems"
      :type="analyticsType"
      :disabled="isDisabled"
    /> -->

    <!-- <grouped-line-chart
      v-if="dimensions && !isDisabled"
      :items="readership"
      :item-groups="lineChartGroups"
      :width="dimensions.width"
      :client-width="clientWidth"
      :min-width="minWidth"
      :height="400"
      :timeframe="timeframePublished"
      :type="analyticsType"
    /> -->

    <multiple-ranking-lists
      v-if="!isDisabled"
      :settings="topListTypes"
      :ranking-lists="topLists"
      :client-width="clientWidth"
      :data="data"
    />
  </div>
</template>

<script>
import {constructFunnelItems, constructBarChartItems, constructReadershipGrouped} from '@/analytics/data-analyser'
import AnalyticsMixin from '@/analytics/mixins/AnalyticsMixin'
import {getTimeframePublishedReadership} from '@/analytics/utils/keen-utils'

import DataWarning from '@/components/DataWarning'
import FilterBar from '@/components/FilterBar'
import Stats from '@/components/Stats'
import FunnelChart from '@/components/d3/FunnelChart'
import BarChart from '@/components/d3/BarChart'
import GroupedLineChart from '@/components/d3/GroupedLineChart'

export default {
  components: {
    DataWarning,
    FilterBar,
    Stats,
    FunnelChart,
    BarChart,
    GroupedLineChart,
  },
  mixins: [AnalyticsMixin],
  data () {
    return {
      analyticsType: 'newsletter',
      lineChartGroups: ['emailReads'],
      basicMetricsShow: ['emailNewsletterViews', 'sendgridClicked', 'sendgridClickedUnique'],
      basicMetricProps: ['emailNewsletterViews',  'emailNewsletterViewsUnique',  'sendgridProcessed', 'sendgridDelivered', 'sendgridOpened', 'sendgridOpenedNetwork', 'sendgridClicked', 'sendgridProcessedUnique', 'sendgridDeliveredUnique', 'sendgridOpenedUnique', 'sendgridClickedUnique', 'sendgridClickedNetwork'],
      timeframe: 'this_5_years',
      topListTypes: {
        newsletterUser: {title: 'Top Readers', path: 'users', colWidth: 12, activeEnabled: false, cols: ['name', 'account', 'emailOpens', 'engagement'], type: 'infinity-rank'},
      },
      enableWarning: true,
    }
  },
  computed: {
    sources () {
      return { sendgrid: ['email_processed', 'email_delivered', 'email_open', 'email_click']}
    },
    timeframePublished () {
      return this.data
        ? getTimeframePublishedReadership(this.data)
        : this.timeframe
    },
    lineChartSources () {
      return {sendgrid: ['emal_open']}
    },
  },
  watch: {
    keenAnalyses: function (newData, oldData) {
      if (newData !== null) {
        this.constructBasicMetrics(this.analyticsType)

        console.log('construct funn itms', this.basicMetrics.current, this.analyticsType)
        this.funnelItems = constructFunnelItems(this.basicMetrics.current, this.analyticsType)
        // TODO: Update for addition channel & network data

        this.funnelProcessed = {
          primary: this.basicMetrics.current.sendgridProcessedUnique,
        }

        this.barChartItems = constructBarChartItems(this.basicMetrics.current, ['sendgridOpened', 'emailNewsletterViews', 'emailNewsletterReads'], this.analyticsType)

        this.readership = constructReadershipGrouped(newData['readership'], this.lineChartSources, this.analyticsType, ['network'])

        this.constructTopList('newsletter', 'user', 'custom_attributes.user_id', this.data._id, {sendgrid: ['email_open']}, 'infinity-rank')
      }
    },
  },
  methods: {
    async fetchStreamAnalyses () {
      const analyses = await this.$keen.fetchStreamAnalyses(this.analyticsType, this.sources, this.timeframe, this.data._id)

      analyses['readership'] = await this.$keen.fetchNewsletterReadership(this.data)

      this.keenAnalyses = analyses
    },
  },
}
</script>
